export default __webpack_public_path__ + "static/media/usuario.18fb694d.svg";